export default [
    {
        path: 'stopwords',
        name: 'list-stopwords',
        component: () => import('pages/stopwords/list'),
    },
    {
        path: 'stopwords/new',
        name: 'create-stopword',
        component: () => import('pages/stopwords/create'),
    },
    {
        path: 'stopwords/:stopwordId',
        name: 'edit-stopword',
        component: () => import('pages/stopwords/create'),
    },
];
